import { createActions, createReducer } from "reduxsauce";

//Action types e Creators
export const { Types, Creators } = createActions({
	gateVariation: ['variation'],
	gateSelect: ['gate'],
	gateVariationClean: [''],
	gateVariationCleanModal: [''],
	gateVariationModal: [''],
	idVariation: [],
	idGate: [''],
	setMotivoVariation: [''],
	setLastDate:[''],
	setInitialDate: [''],
	setFinalDate: [''],
	setHours: [''],
	setNewHours: [''],
	gateVariationHours: [],
	setVariationHoursModalClean: [''],
	setGateVariationError: [''],
	setGateVariationSuccess: [''],
});

//Reducer Handlers
const INITIAL_STATE = {
	gateVariation: [],
	gateSelect: '',
	gateVariationClean: [],
	lastDate: '',
	idVariation: '',
	idGate: '',
	motivo: '',
	initialDate: '',
	finalDate: '',
	gateVariationHours: {
		idVariation: 0,
		capacidadeDinamica: false,
		horarios: [
			{ id: null, idDiaSemana: 1, hrInicial: "08:00:00", hrFim: "18:00:00", intervalo: 1, capacidade: 0, carga: 1 },
			{ id: null, idDiaSemana: 2, hrInicial: "08:00:00", hrFim: "18:00:00", intervalo: 1, capacidade: 2000, carga: 1 },
			{ id: null, idDiaSemana: 3, hrInicial: "08:00:00", hrFim: "18:00:00", intervalo: 1, capacidade: 2000, carga: 1 },
			{ id: null, idDiaSemana: 4, hrInicial: "08:00:00", hrFim: "18:00:00", intervalo: 1, capacidade: 2000, carga: 1 },
			{ id: null, idDiaSemana: 5, hrInicial: "08:00:00", hrFim: "18:00:00", intervalo: 1, capacidade: 2000, carga: 1 },
			{ id: null, idDiaSemana: 6, hrInicial: "08:00:00", hrFim: "18:00:00", intervalo: 1, capacidade: 2000, carga: 1 },
			{ id: null, idDiaSemana: 7, hrInicial: "08:00:00", hrFim: "18:00:00", intervalo: 1, capacidade: 0, carga: 1 }
		]
	},
	gateVariationError: [],
	gateVariationSuccess: [],
}

const getGateVariation = (state = INITIAL_STATE, action) => {
	return { ...state, gateVariation: action.payload }
}

const gateSelect = (state = INITIAL_STATE, action) => {
	return { ...state, gateSelect: action.nome, idGate: action.id }
}

const gateVariationClean = (state = INITIAL_STATE) => {
	return {
		...state,
		gateVariation: INITIAL_STATE.gateVariation
	}
}

const setMotivoVariation = (state = INITIAL_STATE, action) => {
	return {
		...state, motivo: action.payload.motivo,
	}
}

const setInitialDate = (state = INITIAL_STATE, action) => {
	return {
		...state, initialDate: action.payload.initialDate,
	}
}

const setFinalDate = (state = INITIAL_STATE, action) => {
	return {
		...state, finalDate: action.payload.finalDate,
	}
}

const setHours = (state = INITIAL_STATE, action) => {
	return {
		...state, motivo: action.payload.motivo,
		idVariation: action.payload.id,
		initialDate: action.payload.initialDate,
		finalDate: action.payload.finalDate,
		gateVariationHours: {
			horarios: action.payload.horarios
		},
	}
}

const setNewHours = (state = INITIAL_STATE, action) => {
	return {
		...state, horarios: action.payload.horarios,
	}
}

const setLastDate = (state = INITIAL_STATE, action) => {
	return {
		...state, lastDate: action.payload
	}
}

const setVariationsHoursModalClean = (state = INITIAL_STATE, action) => {
	return {
		...state,
		motivo: INITIAL_STATE.motivo,
		initialDate: INITIAL_STATE.initialDate,
		finalDate: INITIAL_STATE.finalDate,
		gateVariationHours: {
			horarios: INITIAL_STATE.gateVariationHours.horarios
		},
	}
}

const setGateVariationError = (state = INITIAL_STATE, action) => {
	return {
		...state,
		gateVariationError: {
			...action.payload
		}
	}
}

const setGateVariationSuccess = (state = INITIAL_STATE, action) => {
	return {
		...state,
		gateVariationSuccess: {
			...action.payload
		}
	}
}

//Criando Reducer
export default createReducer(INITIAL_STATE, {
	[Types.GATE_SELECT]: gateSelect,
	[Types.GATE_VARIATION]: getGateVariation,
	[Types.GATE_VARIATION_CLEAN]: gateVariationClean,
	[Types.SET_LAST_DATE]: setLastDate,
	[Types.SET_MOTIVO_VARIATION]: setMotivoVariation,
	[Types.SET_INITIAL_DATE]: setInitialDate,
	[Types.SET_FINAL_DATE]: setFinalDate,
	[Types.SET_HOURS]: setHours,
	[Types.SET_NEW_HOURS]: setNewHours,
	[Types.SET_VARIATION_HOURS_MODAL_CLEAN]: setVariationsHoursModalClean,
	[Types.SET_GATE_VARIATION_ERROR]: setGateVariationError,
	[Types.SET_GATE_VARIATION_SUCCESS]: setGateVariationSuccess,
});
